import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { ICategoryProductAction, getData, selectItem, tabAction, hideAction, ICategoryProductStoreState } from '@/redux/ui/category-product';

interface IProps {
    hideAction() :void;
    selectItem(index: number, k: number): void;
    tabAction(index: number): void;
    getData(): any;
    lvList1: any[]; // 省列表
    lvList2: any[]; // 市列表
    lvList3: any[]; // 区列表
    lvIndex2: number; // 市索引
    lvIndex3: number; // 区索引
    lvIndex1: number; // 省索引
    tabIndex: number;
    visible: boolean;
};

class CategoryProduct extends React.Component<IProps, any> {
  constructor(props: IProps) {
    super(props);
  }
  public componentDidMount() {
    this.props.getData();
  }

  public render() {
    const props = this.props;
    return (
      <div className={`ui-address ui-category ${props.visible ? 'active' : ''}`}>
        <div className="ui-address-content">
          <div className="ui-address-head">
            <p>选择产品分类</p>
            <span onClick={() => this.hideHandle()}>&times;</span>
          </div>
          <div className="ui-address-dt">
            <div className="ui-address-tab">
              <span className={props.tabIndex === 0 ? 'active' : ''} onClick={() => this.tabHandle(0)}>{props.lvList1[props.lvIndex1] ? props.lvList1[props.lvIndex1].classification_name : '请选择'}</span>
              { props.lvIndex1 > -1 && props.tabIndex > 0 ? <span className={props.tabIndex === 1 ? 'active' : ''} onClick={() => this.tabHandle(1)}>{props.lvList2[props.lvIndex2] ? props.lvList2[props.lvIndex2].classification_name : '请选择'}</span> : null }
            </div>
          </div>
          {
            props.tabIndex === 0 ?
            <div className="ui-address-dd">
              {
                props.lvList1.map((v: any, k: number) => {
                  return (
                    <p className={`${props.lvIndex1 === k ? 'active' : ''}`} key={`proItem-${v.product_id}`} onClick={() => this.selectItem(0, k)}>{v.classification_name}</p>
                  )
                })
              }
            </div>
            : null
          }

          {
            props.tabIndex === 1 ?
            <div className="ui-address-dd">
              {
                props.lvList2.map((v: any, k: number) => {
                  return (
                    <p className={`${props.lvIndex2 === k ? 'active' : ''}`} key={`cityItem-${v.product_id}`} onClick={() => this.selectItem(1, k)}>{v.classification_name}</p>
                  )
                })
              }
            </div>
            : null
          }
        </div>
      </div>
    )
  }
  /**
   * [选择省市区]
   * [选择省市区]
   * @param index [索引] 0 省 1市 2 区
   * @param k [项索引]
   * @param code [父级code码]
   */
  private async selectItem(index: number, k: number) {
    this.props.selectItem(index, k);
  }
  /**
   * [切换]
   * @param index 0 省 1 市 2 区
   */
  private tabHandle(index: number) {
    this.props.tabAction(index);
  }
  /**
   * [隐藏面板]
   */
  private hideHandle() {
    this.props.hideAction();
  }
}

const mapStateToProps = ( state: any ): ICategoryProductStoreState => {
    return {
        ...state.categoryProductReducers
    };
};

const mapDispatchToProps = ( dispatch: Dispatch<ICategoryProductAction> ) => {
    return bindActionCreators({ getData, selectItem, tabAction, hideAction }, dispatch);
};

export default connect( mapStateToProps, mapDispatchToProps )(CategoryProduct);
